import { useChatStore } from '../store/chat-store';
import { Avatar } from './Avatar';

interface Props {
  currentUserId: string;
}

function joinNames(names: string[]): string {
  if (names.length === 0) return '';
  if (names.length === 1) return `${names[0]} is typing`;
  if (names.length === 2) return `${names[0]} and ${names[1]} are typing`;
  if (names.length === 3) return `${names[0]}, ${names[1]} and ${names[2]} are typing`;
  return `${names[0]}, ${names[1]} and ${names.length - 2} others are typing`;
}

export function TypingIndicator({ currentUserId }: Props) {
  const typing = useChatStore(s => s.typing);
  const others = Object.values(typing).filter(t => t.userId !== currentUserId);

  if (others.length === 0) {
    // Reserve no space when nobody is typing — let the layout reflow.
    return null;
  }

  const visibleAvatars = others.slice(0, 3);
  const label = joinNames(others.map(t => t.name));

  return (
    <div className="px-3 pt-1.5 pb-0.5 flex items-center gap-2 text-gray-500">
      <div className="flex -space-x-1.5">
        {visibleAvatars.map(t => (
          <Avatar key={t.userId} userId={t.userId} name={t.name} size={22} ring />
        ))}
      </div>
      <div className="text-[12px] flex items-center gap-1.5">
        <span className="truncate max-w-[60vw]">{label}</span>
        <span className="inline-flex items-center gap-1 ml-1">
          <span className="w-1.5 h-1.5 rounded-full bg-gray-400 typing-dot" />
          <span className="w-1.5 h-1.5 rounded-full bg-gray-400 typing-dot" />
          <span className="w-1.5 h-1.5 rounded-full bg-gray-400 typing-dot" />
        </span>
      </div>
    </div>
  );
}
